import { Component, OnInit, Input, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/platform-browser';
import { DataStoreService } from '../../core/services/data-store/data-store.service';
import { ResourceStoreService } from '../../services/resource-store/resource-store.service';
import { LookAndFillStoreService } from '../../services/look-and-fill-store/look-and-fill-store.service';

@Component({
  selector: 'baf-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  constructor(
    @Inject(DOCUMENT) private document,
    public resource: ResourceStoreService,
    public lookAndFeel: LookAndFillStoreService,
    private storeService: DataStoreService
  ) {
    this.changeFontSize(this.lookAndFeel.fontSize);
  }

  changeTheme() {
    if (this.lookAndFeel.isLightTheme) {
      this.document
        .getElementById('theme1')
        .setAttribute('href', 'assets/css/generic.dark.custom.css');
      this.lookAndFeel.setDarkTheme();
    } else {
      this.document
        .getElementById('theme1')
        .setAttribute('href', 'assets/css/generic.light.custom.css');
      this.lookAndFeel.setLightTheme();
    }
  }

  changeFontSize(fontSize) {
    this.document.documentElement.style.setProperty('--font-size', fontSize + 'px');
    if (fontSize !== this.lookAndFeel.fontSize) {
      this.lookAndFeel.setFontSize(fontSize);
      this.storeService.refreshNode();
    }
  }

  ngOnInit(): void {}
}



// WEBPACK FOOTER //
// ./src/app/components/header/header.component.ts